export default class Validator {
    static validNumberIntType(value) {
        if (/^-?\d*$/.test(value)) {
            return value;
        } else {
            return value.substr(0, value.length - 1);
        }
    }

    static validNumberInt(value, minValue = 0, maxValue = 1) {
        const newValue = isNaN(parseInt(value)) ? 0 : parseInt(value);

        if (newValue <= minValue || value === '') {
            return minValue;
        } else if (newValue >= maxValue) {
            return maxValue;
        } else {
            return newValue;
        }
    }

    static validNumberFloat(value) {
        const newValue = value.replace(/\,/g, '.');

        if (/^-?\d*\.?\d{0,6}$/.test(newValue)) {
            return newValue;
        } else {
            return newValue.substr(0, newValue.length - 1);
        }
    }

    static validGeoCoordinate(value, type) {
        const newValue = value.replace(/\,/g, '.');

        if (type === 'lat') {
            if (newValue <= -90) {
                return -90;
            } else if (newValue >= 90) {
                return 90;
            }
        } else {
            if (newValue <= -180) {
                return -180;
            } else if (newValue >= 180) {
                return 180;
            }
        }

        const returningValue = parseFloat(newValue);
        return isNaN(returningValue) ? 0 : returningValue;
    }
}



// WEBPACK FOOTER //
// ./src/utils/Validator.js